<template>
	<div class="page">
		<!-- 顶部 banner -->
		<div class="banner">
			<img src="../assets/shouye/banner.jpg" alt="来冀云留言 为老师送上节日祝福">
		</div>

		<div class="body-bg">
			<!-- 留言展示区 + 分页 -->
			<message-board :messages="messages" :current-page="pagenow" :total-pages="pagecount" @prev-page="prevPage" @next-page="nextPage" />

			<!-- 学校列表 -->
			<school-grid />

			<!-- 公共留言区 -->
			<public-message @submit="addMessage" :submitting="submitting" ref="publicMessage" />

			<!-- 留言成功弹窗 -->
			 <!-- v-if="showSuccess" -->
			<div class="success-mask" v-if="showSuccess" @click="showSuccess = false">
				<div style="position: relative;width: 70%;margin: 0 auto;">
					<img src="../assets/lycg.png" style="width: 100%;"/>
					<img src="../assets/sure.png" style="position: absolute;bottom: 15%;left: 35%;width: 30%;"/>
				</div>
			</div>

			<!-- 底部 logo -->
			<div class="footer-logo">
				<img src="../assets/shouye/logo.png" alt="长城新媒体">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getFwl,
		getSchoolList,
		postReceive,
		getMsgList
	} from '@/api'
	import { Toast } from 'vant'
	import MessageBoard from '../components/MessageBoard.vue'
	import SchoolGrid from '../components/SchoolGrid.vue'
	import PublicMessage from '../components/PublicMessage.vue'

	export default {
		name: 'index',
		components: {
			MessageBoard,
			SchoolGrid,
			PublicMessage
		},
		data() {
			return {
				pagenow: 1,
				pagecount: 1,
				messages: [],
				submitting: false,
				showSuccess: false
			}
		},
		mounted() {
			getFwl()
			this.getMessages()
		},
		methods: {
			getMessages() {
				getMsgList({ pagenow: this.pagenow }).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data.code === 1) {
						this.pagecount = data.data.pagecount
						this.messages = data.data.sublist.map(function(item) {
							return {
								content: item.content,
								date: item.regdate
							}
						})
					}
				}).catch(() => {

				})
			},
			prevPage() {
				if (this.pagenow > 1) {
					this.pagenow--
					this.getMessages()
				}
			},
			nextPage() {
				if (this.pagenow < this.pagecount) {
					this.pagenow++
					this.getMessages()
				}
			},
			addMessage(content) {
				this.submitting = true
				postReceive({schoolid:"",username:"",teacher:"",content:content}).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data.code === 1) {
						this.showSuccess = true
						this.$refs.publicMessage.clear()
						this.getMessages()
					}
				}).catch(() => {

				}).finally(() => {
					this.submitting = false
				})
			}
		}
	}
</script>

<style scoped>
	.page {
		max-width: 750px;
		margin: 0 auto;
		min-height: 100vh;
		background: #fdf6e9;
		font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
		color: #a34a1f;
	}

	.banner img {
		width: 100%;
	}

	.body-bg {
		background-image: url("../assets/shouye/body-bg.jpg");
		background-size: 100% 100%;
		padding: 20px 12px 44px;
	}

	.footer-logo {
		display: flex;
		justify-content: center;
		margin-top: 30px;
	}

	.footer-logo img {
		width: 35%;
	}

	.success-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 999;
	}

	.success-img {
		width: 70%;
		max-width: 400px;
	}
</style>